export const fireToast = (
  message: string,
  varient:
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "danger"
    | "light"
    | "dark" = "secondary"
) => {
  const toastElem = document.createElement("div");
  toastElem.classList.add("toast", "border-0");
  toastElem.role = "alert";
  toastElem.ariaLive = "assertive";
  toastElem.ariaAtomic = "true";
  toastElem.dataset.controller = "toast";

  const alertElem = document.createElement("div");
  alertElem.classList.add(
    "alert",
    `alert-${varient}`,
    "d-flex",
    "justify-content-between",
    "align-items-center",
    "gap-1"
  );
  alertElem.role = "alert";

  const messageElem = document.createElement("span");
  messageElem.textContent = message;
  alertElem.appendChild(messageElem);

  const closeButtonElem = document.createElement("button");
  closeButtonElem.type = "button";
  closeButtonElem.classList.add("btn-close", "fs-8");
  closeButtonElem.ariaLabel = "Close";
  closeButtonElem.dataset.bsDismiss = "toast";
  alertElem.appendChild(closeButtonElem);

  toastElem.appendChild(alertElem);
  document.querySelector("#toast-container")?.appendChild(toastElem);
};
